import { render, staticRenderFns } from "./ChooseProductFromAllPage.vue?vue&type=template&id=2ccb8956&"
import script from "./ChooseProductFromAllPage.vue?vue&type=script&lang=js&"
export * from "./ChooseProductFromAllPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports